import { Constants } from '../constants';

export class CorizeBaseComponent
{
    public loading :boolean = false;
    public constants : typeof Constants = Constants;
}